<template>
  <div>
    <van-button plain @click="showPopup">其它程式參數</van-button>

    <van-popup
      v-model="visible"
      :style="{ padding: '12px', height: '80%', width: '80%' }"
    >
      <van-tabs>
        <van-tab title="其它程式參數">
          <div v-for="r in tips" :key="r.name">
            <van-tag type="primary" size="large">{{ r.name }}</van-tag>
            <div v-for="r1 in r.children" :key="r1.value">
              <van-cell :label="r1.value" :title="r1.remark" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>
<style scoped>
.van-tag {
  margin: 1rem;
}
.van-button {
  width: auto;
  float: inline-end;
}
</style>
<script>
export default {
  data() {
    return {
      visible: false,
      tips: [
        {
          name: "BK35.作業參數檔",
          children: [
            {
              value: "MPOURL=http://192.168.1.101:3030/",
              remark: "主機網址",
            },
            {
              value: "ShowMPOStatus=Y",
              remark: "檢查有新訂單時, 畫面上方會出現[訂單],BKPOS01/BKPOS02",
            },
            {
              value: "PrintOrderOpenCode=Y",
              remark: "點單加印QRCODE+一次性的驗證碼(必免幽靈點單)",
            },
            {
              value: "QRCodeCheck=Y",
              remark:
                "BKPOS01,桌況畫面上方會多一個[QR結帳], 可掃瞄點單上印的QRCode. 讀出桌號後,自動進入結帳畫面",
            },
          ],
        },
        {
          name: "BNServ.INI",
          children: [
            {
              value: "PassCodeCheck=Y",
              remark: "接收資料會先檢查驗證碼(必免幽靈點單)",
            },
            {
              value: "PrintMPOQRCode=CPrinter",
              remark:
                "用手機行動開桌(必透過BNServ開桌)，列印一張qrcode讓顧客掃描點餐，此點餐qrcode，有支援 PassCodeCheck=Y",
            },
            {
              value: "MaxOrderTime=90",
              remark: "限點時間90分鐘",
            },
            {
              value: "POrder=Y",
              remark:
                "有帶桌號會轉成訂單 + 預點單依區別列印;  '!預點單依區別列印也要勾選'",
            },
          ],
        },
      ],
    };
  },
  mounted() {},
  methods: {
    showPopup() {
      this.visible = true;
    },
  },
};
</script>
  